;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('showClientCard', showClientCardDirective)

  ShowClientCardController.$inject = ['$scope', 'EntityService', 'EntityManager', '$state', 'DisplayService']

  function showClientCardDirective () {
    return {
      restrict: 'E',
      scope: {
        client: '=',
        clickable: '=',
        hideAddress: '=',
        hideParent: '=',
        edit: '=',
        toggle: '&'
      },
      controller: ShowClientCardController,
      controllerAs: '$ctrl',
      templateUrl: '/app/common/directives/show-client-card/show-client-card.html'
    }
  }

  function ShowClientCardController ($scope, EntityService, EntityManager, $state, DisplayService) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        arrowClick: arrowClick
      })
    }

    if (typeof $scope.client === 'string') {
      EntityManager.getById($scope.client).then(function (data) {
        $scope.client = data
      })
    }

    if ($scope.clickable) {
      $scope.toggleContacts = false
    }
    function arrowClick () {
      $scope.toggleContacts = !$scope.toggleContacts
      $scope.toggle({ toggleParent: $scope.toggleContacts })
    }

    /**
    * watcher to populate the client by parent & grandparent
    */
    $scope.$watch('client', function () {
      if (typeof $scope.client === 'string') return
      $scope.client.populate(['parent', 'contacts']).then(function () {
        if ($scope.client && $scope.client.parent && $scope.client.parent.parent) {
          if (typeof $scope.client.parent.parent === 'string') {
            EntityManager.getById($scope.client.parent.parent).then(function (entity) {
              $scope.grandParent = entity
            })
          } else {
            $scope.grandParent = $scope.client.parent.parent
          }
        }
      })

      if (!$scope.hideAddress) {
        $scope.client.populate('defaultAddress')
      }

      $scope.client.populate('currentOccupant')
    })

    /**
     * editEntity - on click show entities' modal
     * @param  {Object} $event description
     */
    $scope.editEntity = function ($event) {
      $event.stopImmediatePropagation()
      const previousType = _.result($scope.client, 'getRealType')
      return DisplayService.confirmEntityEdition().then(function () {
        const query = EntityManager.query({
          populate: JSON.stringify([
            {
              path: 'contacts'
            }
          ])
        })
        return EntityManager.getById($scope.client._id, query)
      }).then((entity) => {
        return EntityService.promptEditEntity(entity, { from: 'sufa' })
      }).then((e) => {
        return EntityManager.getById(e._id, EntityManager.query().populate('contacts'))
      }).then((entity) => {
        // Type modifié depuis la modale : la fiche entité (toolbar, fil d'Ariane) résout
        // l'entité au chargement, on la recharge pour refléter le nouveau type
        if ($state.current.name === 'entity.show' && entity.getRealType() !== previousType) {
          return $state.reload()
        }
        $scope.client = entity
      })
    }

    $scope.showDetail = function () {
      return _.get($scope, 'client.emails', []).length > 1 || _.get($scope, 'client.phones', []).length > 1 || _.get($scope, 'client.currentOccupant.emails', []).length > 1 || _.get($scope, 'client.currentOccupant.phones', []).length > 1
    }

    $scope.detailClient = function ($event) {
      $event.preventDefault()
      $event.stopImmediatePropagation()
      DisplayService.detailClient($scope.client)
    }
  }
})(window.angular, window._)
